import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { Tab } from "../../../Tabs";
import { ProductsList } from "../ProductsList";
import { Typography } from "@parkschannel/ui";
import { sortTreeByAttr } from "@parkschannel/next-utils";
export const CategoryTabs = (param)=>{
    let { data  } = param;
    if (!data || !data.plannerCategories.length) {
        return /*#__PURE__*/ _jsx("div", {
            className: "w-full bg-neutral-100 rounded-lg h-[50px] flex justify-center items-center",
            children: /*#__PURE__*/ _jsx(Typography, {
                variant: "bodyBase",
                children: "Select filters to see categories..."
            })
        });
    }
    return /*#__PURE__*/ _jsx(Tab.CounterTabGroup, {
        scroll: "vertical",
        defaultActiveTab: data.plannerCategories[0].id,
        items: sortTreeByAttr(data.plannerCategories, "position"),
        extractId: (category)=>category.id,
        extractLabel: (category)=>capitalizeFirstLetter(category.title),
        extractTotal: (category)=>(category.children || []).length,
        renderTab: (category)=>/*#__PURE__*/ _jsx(ProductsList, {
                data: category
            }, category.id)
    });
};
function capitalizeFirstLetter(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}
